import React from 'react';
import Library from './Library';
import { getLanguage } from '../../TextManager';
import { translate, parseKeyword, keywordText } from '../../ContentTranslation';

export default function tooltipEffect(effect, content) {
  const curseEffects = [];
  const text = translate(effect || '').replace(/\[([^\]]+)\]/g, (_, label) => {
    const status = Object.values(Library.statuses).find(candidate => candidate.translations?.en?.name === parseKeyword(label).keyword);
    const curseEffect = status?.type === 'curse' && status.translations?.[getLanguage()]?.effect;
    if (curseEffect && !curseEffects.includes(curseEffect)) curseEffects.push(curseEffect);
    return keywordText(label, getLanguage(), status?.translations?.[getLanguage()]?.name);
  });
  return <>{content ?? text}{curseEffects.map(description => <React.Fragment key={description}> <i>({description})</i></React.Fragment>)}</>;
}
